const topbar = {
    docs: 'ドキュメント',
    help: 'ヘルプ',
};
export default Object.freeze(topbar);
